const PersonalHome = r => require.ensure([], () => r(require('./../components/personal/home/Home.vue')), 'personalHome');
// 签约管理
const Sign = r => require.ensure([], () => r(require('./../components/personal/sign/Sign.vue')), 'Sign');
const Template = r => require.ensure([], () => r(require('./../components/personal/sign/Template.vue')), 'Template');
const Record = r => require.ensure([], () => r(require('./../components/personal/sign/Record.vue')), 'Record');
const SignHome = r => require.ensure([], () => r(require('./../components/personal/sign/SignHome.vue')), 'SignHome');
const SignDetail = r => require.ensure([], () => r(require('./../components/personal/sign/SignDetail.vue')), 'SignHome');
const SelectSign = r => require.ensure([], () => r(require('./../components/personal/sign/SelectSign.vue')), 'SignHome');
const Empty = r => require.ensure([], () => r(require('./../components/personal/Empty.vue')), 'Empty');
const SignatureContract = r => require.ensure([], () => r(require('./../components/personal/sign/components/initiateContract/Signature.vue')), 'Signature');
const SelectCertificate = r => require.ensure([], () => r(require('./../components/personal/sign/SelectCertificate.vue')), 'Signature');
const Signpay = r => require.ensure([], () => r(require('./../components/personal/sign/components/sign/pay.vue')), 'Signpay');
const complete = r => require.ensure([], () => r(require('./../components/personal/sign/complete.vue')), 'Signpay');
const contractDetils = r => require.ensure([], () => r(require('./../components/personal/sign/components/template/contractDetils.vue')), 'contractDetils');
const voucher = r => require.ensure([], () => r(require('./../components/personal/sign/Voucher.vue')), 'Signpay');
// 履约管理
const Performances = r => require.ensure([], () => r(require('./../components/personal/performance/Performance.vue')), 'Performance');
const PerformanceList = r => require.ensure([], () => r(require('./../components/personal/performance/PerformanceList.vue')), 'PerformanceList');
const ImplementationDetails = r => require.ensure([], () => r(require('./../components/personal/performance/components/performanceList/ImplementationDetails.vue')), 'ImplementationDetails');
const Performancemession = r => require.ensure([], () => r(require('./../components/personal/performance/components/performanceList/mission.vue')), 'Performancemession');

// 预警
const Warning = r => require.ensure([], () => r(require('./../components/personal/warning/Warning.vue')), 'Warning');
const WarningAdd = r => require.ensure([], () => r(require('./../components/personal/warning/WarningAdd.vue')), 'WarningAdd');

// 司法服务
const Service = r => require.ensure([], () => r(require('./../components/personal/service/Service.vue')), 'Service');
const ServiceHome = r => require.ensure([], () => r(require('./../components/personal/service/ServiceHome.vue')), 'Service');
const Evidence = r => require.ensure([], () => r(require('./../components/personal/service/components/Evidence.vue')), 'Evidence');
const LawyerEvidence = r => require.ensure([], () => r(require('./../components/personal/service/components/lawyerEvidence.vue')), 'LawyerEvidence');

const Procedure = r => require.ensure([], () => r(require('./../components/personal/service/components/procedure.vue')), 'Procedure');
const WriteProcedure = r => require.ensure([], () => r(require('./../components/personal/service/components/writeProcedure.vue')), 'WriteProcedure');
const LawyerCertificate = r => require.ensure([], () => r(require('./../components/personal/service/components/certificate/lawyerCertificate.vue')), 'LawyerCertificate');
const JudicialCertificate = r => require.ensure([], () => r(require('./../components/personal/service/components/certificate/judicialCertificate.vue')), 'judicialCertificate');



// 个人中心
const SetLoginPwd = r => require.ensure([], () => r(require('./../components/personal/user/components/safety/SetloginPwd.vue')), 'SetLoginPwd');
const AmendLoginpwd = r => require.ensure([], () => r(require('./../components/personal/user/components/safety/AmendLoginpwd.vue')), 'AmendLoginpwd');
const SetSignPwd = r => require.ensure([], () => r(require('./../components/personal/user/components/safety/SetsignPwd.vue')), 'SetSignPwd');
const AmendSignPwd = r => require.ensure([], () => r(require('./../components/personal/user/components/safety/AmendSignPwd.vue')), 'AmendSignPwd');
const Cost = r => require.ensure([], () => r(require('./../components/personal/user/Cost.vue')), 'Cost');
const Pay = r => require.ensure([], () => r(require('./../components/personal/user/components/cost/Pay.vue')), 'Pay');
const Signature = r => require.ensure([], () => r(require('./../components/personal/user/Signature.vue')), 'Signature');
const Authorization = r => require.ensure([], () => r(require('./../components/personal/user/Authorization.vue')), 'Authorization');
const Signatory = r => require.ensure([], () => r(require('./../components/personal/user/Signatory.vue')), 'Signatory');
const UserHome = r => require.ensure([], () => r(require('./../components/personal/user/UserHome.vue')), 'UserHome');
const AuthorizedHistory = r => require.ensure([], () => r(require('./../components/personal/user/AuthorizedHistory.vue')), 'AuthorizedHistory');
const PersonalCertificate = r => require.ensure([], () => r(require('./../components/personal/user/PersonalCertificate.vue')), 'PersonalCertificate');
const Enterprise = r => require.ensure([], () => r(require('./../components/personal/user/Enterprise.vue')), 'Enterprise');


//支付方式页面
const Payment = r => require.ensure([], () => r(require('./../components/personal/payment/index.vue')), 'Payment');


export default {
  path: '',
  component: Empty,
  children: [
    // 首页
    {
      path: 'home',
      component: PersonalHome,
    },
    // 签约管理
    {
      path: 'sign/home',
      component: SignHome,
    },
    {
      path: 'sign/index',
      component: Sign
    },
    // 签章
    {
      path: 'sign/index/signature',
      component: SignatureContract,
    },
    {
      path: 'sign/template',
      component: Template,
    },
    {
      path: 'sign/record',
      component: Record,
    },
    {
      path: 'sign/detail',
      component: SignDetail,
    },
    {
      path: 'sign/selectSign',
      component: SelectSign,
    },
    {
      path: 'sign/selectCertificate',
      component: SelectCertificate,
    },
    {
      path: 'sign/complete',
      component: complete,
    },
    {
      path: 'sign/contractDetils',
      component: contractDetils
    },
    {
      path: 'sign/pay.html',
      name: 'Signpay',
      component: Signpay
    },
    {
      path: 'sign/voucher',
      name: 'Signpay',
      component: voucher
    },
    // 履约管理
    {
      path: 'performance/index',
      component: Performances,
    },
    {
      path: 'performance/details',
      component: ImplementationDetails
    },
    {
      path: 'performance/mission',
      component: Performancemession
    },
    {
      path: 'performance/list',
      component: PerformanceList,
    },
    // 预警
    {
      path: 'warning/index',
      component: Warning,
    },
    {
      path: 'warning/add',
      component: WarningAdd,
    },
    // 司法服务
    {
      path: 'service',
      component: Service,
    },
    {
      path: 'serviceHome',
      component: ServiceHome,
    },
    {
      path: 'serviceHome/evidence',
      component: Evidence,
    },
    {
      path: 'serviceHome/lawyerEvidence',
      component: LawyerEvidence
    },
    {
      path: 'serviceHome/evidence/procedure',
      component: Procedure,
    },
    {
      path: "serviceHome/writeProcedure",
      name: 'Describe',
      component: WriteProcedure
    },
    {
      path: 'serviceHome/evidence/lawyerCertificate',
      component: LawyerCertificate
    },
    {
      path: "serviceHome/evidence/judicialCertificate",
      component: JudicialCertificate
    },
    // 个人中心
    {
      path: 'users/home',
      component: UserHome,
    },
    {
      path: 'users/safety/setLoginPwd',
      component: SetLoginPwd
    },

    {
      path: 'users/safety/amendLoginpwd',
      component: AmendLoginpwd
    },
    {
      path: 'users/safety/setSignPwd',
      component: SetSignPwd
    },
    {
      path: 'users/safety/amendSignPwd',
      component: AmendSignPwd
    },
    {
      path: 'users/cost',
      component: Cost,
    },
    {
      path: 'users/cost/pay',
      name: "pay",
      component: Pay,
    },
    {
      path: 'users/signature',
      component: Signature,
    },
    {
      path: 'users/authorization',
      component: Authorization,
    },
    {
      path: 'users/signatory',
      component: Signatory,
    },
    {
      path: 'users/authorizedHistory',
      component: AuthorizedHistory,
    },
    {
      path: 'users/PersonalCertificate',
      component: PersonalCertificate,
    },
    {
      path: "users/enterprise",
      component: Enterprise
    },
    //支付页面
    {
      path:"payment",
      component:Payment
    }
  ]
}